import { Avatar, AvatarFallback } from "components/ui/avatar";
import { Skeleton } from "components/ui/skeleton";
import { cn } from "@/lib/utils";
import { Link as RouterLink } from "react-router-dom";
import { generatePath } from "react-router";
import * as Routes from "routes";

export function NameEmailAvatarRound(props: {
  name: string;
  email: string;
  isLoading: boolean;
  variant: "circular" | "square" | "rounded" | undefined;
  textBoxWidth?: string;
  userId?: string;
  orgId?: string;
  isAdmin?: boolean;
}) {
  const userLink =
    props.userId && props.orgId
      ? generatePath(
          props.isAdmin ? Routes.AdminMemberDetails : Routes.orgMemberDetails,
          {
            accountId: props.userId,
            orgId: props.orgId,
          },
        )
      : "#";

  const avatarShapeClass =
    props.variant === "circular"
      ? "rounded-full"
      : props.variant === "square"
        ? "rounded-none"
        : "rounded-md";

  if (props.isLoading) {
    return (
      <Skeleton
        className={cn(
          "size-10",
          props.variant === "circular" ? "rounded-full" : "rounded-md",
        )}
      />
    );
  }

  if (!props.name) {
    return (
      <div className="flex flex-row items-center gap-2">
        <Avatar className={cn("size-10", avatarShapeClass)}>
          <AvatarFallback className={avatarShapeClass} />
        </Avatar>
        <p className="text-sm mt-5">{props.email}</p>
      </div>
    );
  }

  const nameNode = props.userId ? (
    <RouterLink
      to={userLink}
      className="text-primary hover:underline cursor-pointer"
    >
      {props.name}
    </RouterLink>
  ) : (
    <span>{props.name}</span>
  );

  const emailNode = props.userId ? (
    <RouterLink
      to={userLink}
      className="text-muted-foreground text-xs hover:underline cursor-pointer"
    >
      {props.email}
    </RouterLink>
  ) : (
    <span className="text-muted-foreground text-xs">{props.email}</span>
  );

  return (
    <div className="flex flex-row items-center gap-2 justify-between">
      <Avatar className={cn("size-10", avatarShapeClass)}>
        <AvatarFallback className={avatarShapeClass}>
          {stringAvatar(props.name).children}
        </AvatarFallback>
      </Avatar>
      <div
        className="flex flex-col min-w-0"
        style={props.textBoxWidth ? { width: props.textBoxWidth } : undefined}
      >
        <div className="truncate">{nameNode}</div>
        <div className="truncate">{emailNode}</div>
      </div>
    </div>
  );
}

export function stringAvatar(name: string) {
  name = name.trim();
  let shortName = "";

  if (!name) {
    shortName = "";
  } else if (name.length === 1) {
    shortName = name[0].toUpperCase();
  } else if (!name.includes(" ")) {
    shortName = `${name[0].toUpperCase()}${name[1].toLowerCase()}`;
  } else {
    const withoutExtraWhitespace = name.replace(/ +(?= )/g, "");
    const nameFragments: string[] = withoutExtraWhitespace.split(" ");
    shortName = `${nameFragments[0][0].toUpperCase()}${nameFragments[1][0].toUpperCase()}`;
  }

  return {
    children: shortName,
  };
}
